module.exports = __webpack_public_path__ + "static/media/YM48_1.a4584ff4.jpg";